import * as React from "react";

import Logocrom from "assets/video/Logocrom.gif";
import pageStyles from "./styles/BannerLandingStyles";
import { Link } from "@mui/material";
import { RoutesPaths as Routes } from "pages/routes";

const BannerLandingScreen = () => {
  const styles = pageStyles();

  return (
    <>
      <div className={styles.bannerContainer}>
        <div className={styles.columnBannerLeft}>
          <div className={styles.containerImageLogo}>
            <img src={Logocrom} alt="FROIN" className={styles.imageLogo} />
          </div>
          <div className={styles.overlayVideo} />
        </div>
        <div className={styles.columnBanner}>
          <h1 className={styles.titleBanner}>
            Exponemos artistas, recompensamos espectadores y conectamos marcas
          </h1>
          <p className={styles.descriptionBanner}>
            Somos la plataforma que une a la comunidad donde todos ganan.
            Descubre, apoya y vive el entretenimiento de una forma diferente,
            con resultados reales y experiencias que trascienden lo digital.
          </p>
          <Link className={styles.buttonBanner} href={Routes.detailVideo}>
            Reproduce y Gana
          </Link>
        </div>
      </div>
    </>
  );
};

export default BannerLandingScreen;
